export const rm = (n) =>
  "RM " + Number(n || 0).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const qty = (n, unit) =>
  unit === "kg" ? `${Number(n || 0).toFixed(3).replace(/\.?0+$/, "") || 0} kg` : `${Number(n || 0)} unit`;

export const dt = (iso) =>
  new Date(iso).toLocaleString("ms-MY", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const dateOnly = (iso) =>
  new Date(iso).toLocaleDateString("ms-MY", { day: "2-digit", month: "short", year: "numeric" });

export const todayStr = (offsetDays = 0) => {
  const d = new Date(Date.now() + 8 * 3600000 + offsetDays * 86400000);
  return d.toISOString().slice(0, 10);
};

export const monthStart = () => todayStr().slice(0, 8) + "01";

export const roundCash = (x) => Math.round(Math.round(x * 20) / 20 * 100) / 100;

export const METHOD_LABEL = { tunai: "Tunai", qr: "QR DuitNow", online: "Online (App)" };

const ONES = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "lapan", "sembilan"];

function below1000(n) {
  const out = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;
  if (h) out.push(h === 1 ? "seratus" : `${ONES[h]} ratus`);
  if (rest >= 20) {
    out.push(`${ONES[Math.floor(rest / 10)]} puluh`);
    if (rest % 10) out.push(ONES[rest % 10]);
  } else if (rest >= 12) out.push(`${ONES[rest - 10]} belas`);
  else if (rest === 11) out.push("sebelas");
  else if (rest === 10) out.push("sepuluh");
  else if (rest) out.push(ONES[rest]);
  return out.join(" ");
}

function intWords(n) {
  if (n === 0) return "kosong";
  const parts = [];
  const m = Math.floor(n / 1e6);
  const t = Math.floor((n % 1e6) / 1000);
  const r = n % 1000;
  if (m) parts.push(`${below1000(m)} juta`);
  if (t) parts.push(t === 1 ? "seribu" : `${below1000(t)} ribu`);
  if (r) parts.push(below1000(r));
  return parts.join(" ");
}

export function ringgitWords(amount) {
  const total = Math.round(Number(amount || 0) * 100);
  const rgt = Math.floor(total / 100);
  const sen = total % 100;
  let s = `Ringgit Malaysia ${intWords(rgt)}`;
  if (sen) s += ` dan sen ${intWords(sen)}`;
  return (s + " sahaja").replace(/\s+/g, " ");
}
